module.exports = __webpack_public_path__ + "static/media/Beg.446af878.jpg";